import { render, staticRenderFns } from "./ExhibitorshallMobile.vue?vue&type=template&id=4fe1a0f2"
import script from "./ExhibitorshallMobile.vue?vue&type=script&lang=js"
export * from "./ExhibitorshallMobile.vue?vue&type=script&lang=js"
import style0 from "./ExhibitorshallMobile.vue?vue&type=style&index=0&id=4fe1a0f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports